<template>
    <router-link to="/">
        <div class="header-logo-parent">
            <div class="header-logo-parent__logo">
                <svg
                    class="header-logo-svg mt-4"
                    width="140"
                    height="100"
                    viewBox="0 0 79 55"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M78.9974 13.726C78.8381 13.5735 73.027 14.7675 69.3917 15.6821C64.5092 16.9269 58.9634 18.9338 55.6996 20.6867C55.62 20.7375 55.0362 19.3657 54.3994 17.6636C51.3479 9.17863 46.9696 2.75137 42.9363 0.795255C41.0258 -0.144699 38.8234 -0.246316 36.9128 0.465001C35.0023 1.20172 31.9773 3.97077 29.9341 6.89225C28.0501 9.58509 25.9539 13.4973 24.1495 17.7398L22.8626 20.7553C22.0904 19.9246 20.8539 19.2768 20.0339 18.911C14.7747 16.5636 9.01659 15.1867 3.31688 14.2366C0.875655 13.8301 0 13.7539 0 13.9317C0 14.008 0.42456 15.4052 0.928725 17.0819C3.47609 25.6431 8.65041 35.2204 13.9043 41.2158C20.2727 48.4814 28.1006 53.232 35.9549 54.6038C36.6625 54.7224 35.9461 53.7739 33.8056 51.7585C32.0277 50.1073 29.6661 47.5668 28.5517 46.1188C23.9293 40.1133 21.1882 32.7334 21.9471 25.2036C22.2257 22.4218 22.8519 20.9839 22.8679 20.7985L24.0699 21.4742C30.4118 25.0308 34.0471 29.6798 37.2843 38.4188C37.6824 39.5366 38.1334 40.5528 38.2396 40.6798C38.4864 40.9745 41.7634 37.644 42.0394 37.3645C42.3844 37.0165 42.7267 36.6634 43.0663 36.3103C43.2149 36.1553 43.9632 35.3754 43.9181 35.3068C45.8817 38.1724 46.1019 42.0872 45.5818 45.3872C45.2024 47.7929 44.3718 50.1352 43.2069 52.2971C42.9655 52.7442 42.7081 53.1812 42.4348 53.6105C42.0102 54.2964 41.6918 54.9061 41.7714 54.9823C41.8245 55.0585 42.8593 54.8807 44.0534 54.5759C58.515 51.0701 70.8272 37.6059 77.8059 17.6128C78.5224 15.5551 79.0531 13.8022 79 13.726H78.9974Z"
                    />
                </svg>
            </div>
            <div class="ml-5 d-none d-sm-block">
                <p class="header-logo-title">РАИИ</p>
                <p class="header-logo-text">РОССИЙСКАЯ АССОЦИАЦИЯ</p>
                <p class="header-logo-text">ИСКУССТВЕННОГО ИНТЕЛЛЕКТА</p>
                <p class="header-logo-text">ОСНОВАНА В 1989 ГОДУ</p>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    name: 'HeaderLogo'
}
</script>

<style scoped lang="scss">  
a {
    text-decoration: none;
    color: unset;
}
</style>
